export type JsonRequest<T> = {
  data: T;
};

export const mapDataToRequest = <T>(data: T): JsonRequest<T> => ({ data });
